import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { podCastInfo } from "../../../SchemaInfo/info";
import { podCastSchema } from "../../../Schemas/Media And Marketing/podcast.schema";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { FcClapperboard, FcCollaboration } from "react-icons/fc";
import axios from "axios";
import { useRef } from "react";
import * as Yup from "yup";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
// import { useRef } from "react";
import { toPng } from "html-to-image";
import PodcastCard from "../../Editing Tamplate/templateEditor"; // your template component
import PodcastGuest2Card from "../../Editing Tamplate/podcastGuest2";
import QuoteCard from "../../Editing Tamplate/QuoteTamplate";
import CrouselNewsCard from "../../Editing Tamplate/crouselUImage";
import {
  BsBoxArrowDown,
  BsBoxArrowDownRight,
  BsBoxArrowInRight,
} from "react-icons/bs";

const Editpodcast = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let { id } = useParams();
  const [podcast, setPodcast] = useState(podCastInfo);
  const [socialMedia, setSocialMedia] = useState([]);
  const [guest, setGuest] = useState([]);

  const [schedules, setSchedules] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const fileInputRef = useRef(null);
  const thumbnailInputRef = useRef(null);
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  // const templateRef = useRef(null);

  const podcastGuestRef = useRef(null);
  const podcastGuestSecondRef = useRef(null);
  const quoteRef = useRef(null);

  const carouselRef = useRef(null);

  const [currentTemplateSlide, setCurrentTemplateSlide] = useState({
    carousel: null,
    podcastGuestSecond: null,
  });

  const templateRefs = {
    podcastGuest: podcastGuestRef,
    podcastGuestSecond: podcastGuestSecondRef,
    quote: quoteRef,
    carousel: carouselRef,

    // template4: template4Ref,
  };

  const templatePlanMap = {
    "PLAN-1784116305499": "podcastGuest",
    "PLAN-1783935974809": "quote",
    "PLAN-1783936989539": "carousel",
    "PLAN-1784116206988": "podcastGuestSecond",
    "PLAN-1784116397839": "quote",
  };

  const [filters, setFilters] = useState({
    date: "",
    day: "",
  });

  useEffect(() => {
    const getSchedules = async () => {
      try {
        setLoading(true);

        const res = await performRequest(
          "GET",
          "/postPlanning/get-podcast-schedules/"
        );

        if (res.status === 200) {
          console.log("Schedules", res.data?.data);

          setSchedules(res.data?.data || []);
        }
      } catch (error) {
        CustomErrorResponse(error);
      } finally {
        setLoading(false);
      }
    };

    getSchedules();
  }, []);

  const getHistory = async (id) => {
    try {
      setHistoryLoading(true);

      const response = await performRequest(
        "GET",
        `/postPlanning/get-podcast-history/${id}`
      );

      if (response.status === 200) {
        setHistory(response.data?.data || []);
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getHistory(id);
    }
  }, [id]);


   const generatePngFromElement = async (element) => {
      if (!element) {
        throw new Error("Template element not found");
      }
  
      // Save original styles
      const originalStyles = {
        width: element.style.width,
        height: element.style.height,
        minWidth: element.style.minWidth,
        minHeight: element.style.minHeight,
        maxWidth: element.style.maxWidth,
        maxHeight: element.style.maxHeight,
        transform: element.style.transform,
        transformOrigin: element.style.transformOrigin,
      };
  
      try {
        // IMPORTANT:
        // Lock template to fixed 1080 x 1350 during image generation
        element.style.width = "1080px";
        element.style.height = "1350px";
        element.style.minWidth = "1080px";
        element.style.minHeight = "1350px";
        element.style.maxWidth = "1080px";
        element.style.maxHeight = "1350px";
        element.style.transform = "none";
        element.style.transformOrigin = "top left";
  
        // Force browser to calculate layout again
        void element.offsetWidth;
  
        // Wait for render
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
  
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
  
        // Generate fixed-size PNG
        const dataUrl = await toPng(element, {
          cacheBust: true,
  
          width: 1080,
          height: 1350,
  
          canvasWidth: 1080,
          canvasHeight: 1350,
  
          pixelRatio: 1,
  
          style: {
            width: "1080px",
            height: "1350px",
            minWidth: "1080px",
            minHeight: "1350px",
            maxWidth: "1080px",
            maxHeight: "1350px",
            transform: "none",
            transformOrigin: "top left",
          },
        });
  
        return dataUrl;
      } finally {
        // Restore original styles
        element.style.width = originalStyles.width;
        element.style.height = originalStyles.height;
        element.style.minWidth = originalStyles.minWidth;
        element.style.minHeight = originalStyles.minHeight;
        element.style.maxWidth = originalStyles.maxWidth;
        element.style.maxHeight = originalStyles.maxHeight;
        element.style.transform = originalStyles.transform;
        element.style.transformOrigin = originalStyles.transformOrigin;
      }
    };


  const generateTemplateImage = async (values) => {
    try {
      console.log("Generating template...");

      // Wait React render
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      const element = templateRefs[values.templateName]?.current;

      if (!element) {
        console.error("Template not found");
        return null;
      }

      console.log("Element:", element);

      // Wait for state update
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const images = Array.from(element.querySelectorAll("img"));

      console.log("Images found:", images.length);

      await Promise.all(
        images.map(async (img, index) => {
          console.log("Image before load", index, {
            srcAttribute: img.getAttribute("src"),
            src: img.src,
            complete: img.complete,
            naturalWidth: img.naturalWidth,
          });

          // invalid image
          if (!img.getAttribute("src")) {
            console.log("Empty image", index);
            return;
          }

          if (img.complete && img.naturalWidth > 0) {
            if (img.decode) {
              try {
                await img.decode();
              } catch (e) {}
            }

            return;
          }

          await new Promise((resolve) => {
            img.onload = async () => {
              console.log("Loaded image", index);

              if (img.decode) {
                try {
                  await img.decode();
                } catch (e) {}
              }

              resolve();
            };

            img.onerror = () => {
              console.log("Image error", index, img.src);

              resolve();
            };
          });
        })
      );

      // final render wait
      await new Promise((resolve) => setTimeout(resolve, 500));

      console.log("Before PNG");

      images.forEach((img, index) => {
        console.log("Final image", index, {
          src: img.src,
          width: img.naturalWidth,
        });
      });

      // const dataUrl = await toPng(element, {
      //   cacheBust: true,
      //   pixelRatio: 1,
      //   width: 1080,
      //   height: 1350,
      //   canvasWidth: 1080,
      //   canvasHeight: 1350,
      // });

      const dataUrl = await generatePngFromElement(element);

      console.log("PNG Generated");

      const blob = await fetch(dataUrl).then((res) => res.blob());

      const file = new File(
        [blob],
        `${values.templateName}-${Date.now()}.png`,
        {
          type: "image/png",
        }
      );

      const signedRes = await performRequest(
        "POST",
        "/postPlanning/generateUploadUrl",
        {
          fileName: file.name,
          contentType: file.type,
        }
      );

      await axios.put(signedRes.data.uploadUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      console.log("Uploaded", signedRes.data.publicUrl);

      return signedRes.data.publicUrl;
    } catch (error) {
      console.error("generateTemplateImage error", error);

      return null;
    }
  };

  const generateTemplateCarouselImage = async (values) => {
    try {
      let slides = [];
      let activeRef = null;
      let templateKey = values.templateName;
      setSubmitting(true);
      // ============================
      // SELECT CAROUSEL TYPE
      // ============================

      if (templateKey === "carousel") {
        slides = values.templateData.slides;
        activeRef = carouselRef;
      } else if (templateKey === "podcastGuestSecond") {
        slides = values.templateData.guestCarouselSlides;
        activeRef = podcastGuestSecondRef;
      } else {
        return await generateTemplateImage(values);
      }

      const uploadedUrls = [];

      // ============================
      // LOOP SLIDES
      // ============================

      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];

        if (!slide) {
          continue;
        }

        console.log("Generating", templateKey, "Slide", i + 1);

        // ============================
        // SET CURRENT SLIDE
        // ============================

        setCurrentTemplateSlide({
          carousel: templateKey === "carousel" ? slide : null,

          podcastGuestSecond:
            templateKey === "podcastGuestSecond" ? slide : null,
        });

        // wait react render

        await new Promise((r) => requestAnimationFrame(r));
        await new Promise((r) => requestAnimationFrame(r));
        await new Promise((r) => setTimeout(r, 1500));

        const element = activeRef.current;

        if (!element) {
          console.log("Ref not found", templateKey);
          continue;
        }

        // ============================
        // WAIT IMAGES
        // ============================

        const images = [...element.querySelectorAll("img")];

        await Promise.all(
          images.map((img) => {
            if (img.complete && img.naturalWidth > 0) {
              return Promise.resolve();
            }

            return new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
            });
          })
        );

        await new Promise((r) => setTimeout(r, 300));

        // ============================
        // PNG
        // ============================

        // const dataUrl = await toPng(element, {
        //   cacheBust: true,
        //   pixelRatio: 1,
        //   width: 1080,
        //   height: 1350,
        //   canvasWidth: 1080,
        //   canvasHeight: 1350,
        // });

        const dataUrl = await generatePngFromElement(element);

        const blob = await fetch(dataUrl).then((r) => r.blob());

        const file = new File(
          [blob],
          `${templateKey}-${i + 1}-${Date.now()}.png`,
          {
            type: "image/png",
          }
        );

        const signedRes = await performRequest(
          "POST",
          "/postPlanning/generateUploadUrl",
          {
            fileName: file.name,
            contentType: file.type,
          }
        );

        await axios.put(signedRes.data.uploadUrl, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        uploadedUrls.push(encodeURI(signedRes.data.publicUrl));

        console.log("Uploaded slide", i + 1);
      }

      return uploadedUrls;
    } catch (err) {
      console.error("Carousel Error", err);

      return [];
    } finally {
      setSubmitting(false);
    }
  };

  const handelSubmitNNew = async (values) => {
    try {
      let uploadedUrls = [];

      let templateImageUrl = null;

      if (values.templateName && values?.type === "Template Upload") {
        console.log("Generating template...");
        templateImageUrl = await generateTemplateCarouselImage(values);
        console.log("Generated:", templateImageUrl);
      }

      console.log("Continue submit...");

      console.log("tamplte url", templateImageUrl);

      setSubmitting(true);

      // Thumbnail
      let thumbnailUrl =
        typeof values.thumbnail === "string"
          ? values.thumbnail
          : values.thumbnail;

      // Upload thumbnail if it's a new file
      if (values.thumbnail && typeof values.thumbnail !== "string") {
        const signedRes = await performRequest(
          "POST",
          "/postPlanning/generateUploadUrl",
          {
            fileName: values.thumbnail.name,
            contentType: values.thumbnail.type,
          }
        );

        await axios.put(signedRes.data.uploadUrl, values.thumbnail, {
          headers: {
            "Content-Type": values.thumbnail.type,
          },
        });

        // Save encoded public URL
        thumbnailUrl = encodeURI(signedRes.data.publicUrl);
      }

      if (values.images && values.images.length > 0) {
        for (const file of values.images) {
          // If it's already a URL, encode it and keep it
          if (typeof file === "string") {
            uploadedUrls.push(file); // Keep the existing URL unchanged
            continue;
          }

          // 1. Get signed URL
          const signedRes = await performRequest(
            "POST",
            "/postPlanning/generateUploadUrl",
            {
              fileName: file.name,
              contentType: file.type,
            }
          );

          // 2. Upload directly to GCS
          await axios.put(signedRes.data.uploadUrl, file, {
            headers: {
              "Content-Type": file.type,
            },
          });

          // 3. Save encoded public URL
          uploadedUrls.push(encodeURI(signedRes.data.publicUrl));
        }
      }

      // ================================
      // FINAL IMAGE ARRAY
      // ================================

      let finalImages = [];

      if (
        values.templateName === "carousel" &&
        values.type === "Template Upload"
      ) {
        // Add fixed first and last image only for carousel
        finalImages = [
          "https://res.cloudinary.com/bsgfcooa/image/upload/v1785394742/fist_slide_kxyk8a.png",

          ...(Array.isArray(templateImageUrl) ? templateImageUrl : []),

          "https://res.cloudinary.com/bsgfcooa/image/upload/v1785394742/last_slide_vv1xpx.png",
        ];
      } else if (
        Array.isArray(templateImageUrl) &&
        values.type === "Template Upload"
      ) {
        finalImages = templateImageUrl;
      } else if (templateImageUrl && values.type === "Template Upload") {
        finalImages = [templateImageUrl];
      } else {
        finalImages = uploadedUrls;
      }

      // Update schedule
      const response = await performRequest(
        "PATCH",
        "/postPlanning/update-latest-schedule",
        {
          id: values.id,
          script: values.script,
          platforms: values.platforms,
          scheduleId: values.scheduleId,
          images: finalImages,
          templateName: values.templateName,
          liveDate: values.liveDate,
          thumbnail: thumbnailUrl,
          deletedImages: values.deletedImages || [],
          deletedThumbnail: values.deletedThumbnail,
          updatedBy: store?.Name || "",
          podcastId: id || "",
        }
      );

      if (response.status === 200) {
        Toast("success", "Schedule updated successfully");
        // // close modal
        // const closeBtn = document.getElementById(`modal-close-planning`);

        // if (closeBtn) {
        //   closeBtn.click();
        // }
        // navigate(`/edit-podcast/${id}`);
        await getHistory(id);

        const closeBtn = document.getElementById("modal-close-planning");

        if (closeBtn) {
          closeBtn.click();
        }
      }
    } catch (error) {
      CustomErrorResponse(error);
    } finally {
      setSubmitting(false);
    }
  };

  const getFileSrc = (file) => {
    if (file instanceof File) {
      return URL.createObjectURL(file);
    }

    if (typeof file === "string") {
      return file;
    }

    return file?.url || "";
  };

  const isVideo = (file) => {
    if (file instanceof File) {
      return file.type.startsWith("video/");
    }

    const src = typeof file === "string" ? file : file?.url || "";

    return /\.(mp4|mov|avi|webm|mkv)$/i.test(src);
  };

  // const getHistory = async (id) => {
  //   try {
  //     setHistoryLoading(true);

  //     const response = await performRequest(
  //       "GET",
  //       `/postPlanning/history/${id}`
  //     );

  //     if (response.status === 200) {
  //       setHistory(response.data.data);
  //     }
  //   } catch (err) {
  //     CustomErrorResponse(err);
  //   } finally {
  //     setHistoryLoading(false);
  //   }
  // };

  const validationSchema = Yup.object({
    script: Yup.string().trim().required("Script is required"),
    type: Yup.string().trim().required("Type is required"),
  });

  const handelSubmit = (values) => {
    setLoading(true);
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("PATCH", `/podcast/update/${id}`, values, headers)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Podcast updated successfully!");
          navigate(`/podcasts/view/${id}`);
        } else {
          Toast("error", "Error while updating podcast");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/getpodcastbyId/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setPodcast(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting Lead!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/social-media-users`)
      .then((res) => {
        if (res.status === 200) {
          setSocialMedia(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting social media!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/guest/get-all-guest`)
      .then((res) => {
        if (res.status === 200) {
          setGuest(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting guests!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const templatePreview = {
    podcastGuest:
      "https://res.cloudinary.com/bsgfcooa/image/upload/v1785576655/Req-payment/prvsbmchb2atnvpjnnee.jpg",
    podcastGuestSecond:
      "https://res.cloudinary.com/bsgfcooa/image/upload/v1785924893/3-guest-quote-carousel-WED_3_xxzytx.png",
    quote:
      "https://res.cloudinary.com/bsgfcooa/image/upload/v1785924917/1784787299840-hm-quote-template_Data_Set_32-01_1_jemaqp.jpg",
    carousel:
      "https://res.cloudinary.com/bsgfcooa/image/upload/v1785924957/news-card_ux4lqn.png",
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCollaboration></FcCollaboration> Podcast
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Podcast</h2>
            </div>
            <Formik
              initialValues={podcast}
              validationSchema={podCastSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <h3> Planning Podcast </h3>
                    <hr className=""></hr>

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="podcastName"
                        ></CustomInput>
                        {props.touched.podcastName &&
                          props.errors.podcastName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastName}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="podcastDescription"
                        ></CustomTextArea>
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Branding Assets
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastBrand"
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value="Kryzen Biotech">
                            Kryzen Biotech{" "}
                          </option>
                          <option value="Hydroponic Masterclass">
                            Hydroponic Masterclass
                          </option>
                          <option value="Sudhir Devkar">Sudhir Devkar</option>
                          <option value="Eat Pure Greens">
                            Eat Pure Greens
                          </option>
                        </CustomSelect>

                        {props.touched.podcastBrand &&
                          props.errors.podcastBrand && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastBrand}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3 required">
                      Guest Name
                    </label>
                    <div className="w-100 col">
                      <CustomInput
                        type={"text"}
                        className="form-control"
                        name="guestName"
                      ></CustomInput>
                    </div>
                  </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Guest Name
                      </label>
                      <div className="w-100 col">
                        {/* <CustomInput
                        type={"text"}
                        className="form-control"
                        name="podcastEditor"
                      ></CustomInput> */}

                        <CustomSelect name="guestName">
                          <option value="">Select</option>
                          {guest?.map((item, index) => {
                            return (
                              <option key={index} value={item?.guestName}>
                                {item?.guestName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Type
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastType"
                          className="form-control"
                        >
                          <option value="">Select Podcast Type</option>
                          <option value="Single Guest">Single Guest</option>
                          <option value="Multiple Guest">Multiple Guest</option>
                        </CustomSelect>

                        {props.touched.podcastType &&
                          props.errors.podcastType && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastType}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Language
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastLanguage"
                          className="form-control"
                        >
                          <option value="">Select Language</option>
                          <option value="Hindi">Hindi</option>
                          <option value="Marathi">Marathi</option>
                          <option value="English">English</option>
                        </CustomSelect>

                        {props.touched.podcastLanguage &&
                          props.errors.podcastLanguage && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastLanguage}{" "}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Series Name
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastseriesName"
                          className="form-control"
                        >
                          <option value="">Select Type</option>
                          <option value="Marathi - खरं बोलायचं तर (policy makers, government officials, activists)">
                            Marathi: खरं बोलायचं तर (policy makers, government
                            officials, activists)
                          </option>
                          <option value="Marathi - खरा खेळ (Business people)">
                            Marathi: खरा खेळ (Business people)
                          </option>
                          <option value="Marathi - अन्नदाता (Farmers)">
                            Marathi: अन्नदाता (Farmers)
                          </option>
                          <option value="Hindi - सच की बात (policy makers, government officials, activists)">
                            Hindi : सच की बात (policy makers, government
                            officials, activists)
                          </option>
                          <option value="Hindi - असली खेल (Business people)">
                            Hindi - असली खेल (Business people)
                          </option>
                          <option value="Hindi - कारोबारी किसान (Farmers)">
                            Hindi - कारोबारी किसान (Farmers)
                          </option>
                          <option value="English - (Policy Makers / Government / Activists)">
                            English - (Policy Makers / Government / Activists)
                          </option>
                          <option value="English - (Business People)">
                            English - (Business People)
                          </option>
                          <option value="English - (Farmers)">
                            English - (Farmers)
                          </option>
                        </CustomSelect>

                        {props.touched.podcastseriesName &&
                          props.errors.podcastseriesName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastseriesName}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Planning Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="podcastDate"
                        ></CustomInput>
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Guest City
                    </label>
                    <div className="w-100 col">
                      <CustomInput
                        type={"text"}
                        className="form-control"
                        name="guestCity"
                      ></CustomInput>
                    </div>
                  </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Guest Previous podcast reference
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestPrvRef"
                        ></CustomInput>
                        {props.touched.guestPrvRef &&
                          props.errors.guestPrvRef && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestPrvRef}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr></hr>
                    <h3>Podcast Shooting </h3>
                    <hr></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Venue
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="podcastVenue"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Shooting Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="shootingDate"
                        ></CustomInput>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Edit Podcast" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            <hr className="m-0 p-0"></hr>
            <h3 className="p-3">Add In Schedule </h3>
            <hr className="p-0 m-0"></hr>
            <div className="p-3">
              <button
                className="mx-1 btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target={`#modal-schedule-planning`}
                title="Add Schedule"
              >
                {/* <FiEdit size={18} /> */}
                <BsBoxArrowInRight className="fs-2 me-2" /> ADD IN SCHEDULE
              </button>
            </div>
            {/* ================= PODCAST SCHEDULE HISTORY ================= */}

            <hr className="mt-4 mb-0" />

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Podcast Schedule History</h3>
              </div>

              <div className="table-responsive">
                <table className="table table-vcenter table-bordered card-table">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Schedule ID</th>
                      <th>Type</th>
                      <th>Schedule Name</th>
                      <th>Live Date</th>
                      <th>Images</th>
                      <th>Script</th>
                      <th>Generated By</th>
                      <th>Created At</th>
                    </tr>
                  </thead>

                  <tbody>
                    {historyLoading ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>

                          <span className="ms-2">
                            Loading schedule history...
                          </span>
                        </td>
                      </tr>
                    ) : history?.length > 0 ? (
                      history.map((item, index) => (
                        <tr key={item?.id || index}>
                          <td>{index + 1}</td>

                          <td>{item?.scheduleId || "N/A"}</td>

                          <td>
                            <span className="badge bg-blue-lt">
                              {item?.type || "N/A"}
                            </span>
                          </td>

                          <td>{item?.scheduleName || "N/A"}</td>

                          <td>{item?.liveDate || "N/A"}</td>

                          <td>
                            {Array.isArray(item?.images) &&
                            item.images.length > 0 ? (
                              <div className="d-flex flex-wrap gap-2">
                                {item.images.map((image, imageIndex) => (
                                  <a
                                    key={imageIndex}
                                    href={image}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <img
                                      src={image}
                                      alt={`Schedule ${imageIndex + 1}`}
                                      style={{
                                        width: "70px",
                                        height: "70px",
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                      }}
                                    />
                                  </a>
                                ))}
                              </div>
                            ) : (
                              <span className="text-muted">No Media</span>
                            )}
                          </td>

                          <td
                            style={{
                              minWidth: "250px",
                              maxWidth: "350px",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {item?.script || "N/A"}
                          </td>

                          <td>{item?.generatedBy || "N/A"}</td>

                          <td>
                            {item?.createdAt
                              ? new Date(item.createdAt).toLocaleString("en-IN")
                              : "N/A"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center py-5">
                          <h4 className="mb-1">No Schedule History Found</h4>

                          <span className="text-muted">
                            No schedule history is available for this podcast.
                          </span>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div
              className="modal modal-blur fade"
              id={`modal-schedule-planning`}
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Schedule</h5>

                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id={`modal-close-planning`}
                    ></button>
                  </div>

                  <Formik
                    initialValues={{
                      script: "",
                      liveDate: "",
                      images: [],
                      platforms: [],
                      templateData: {
                        // Podcast Guest
                        guestImage: "",
                        guestImageFile: "",
                        firstName: "",
                        lastName: "",

                        // Podcast Guest Second
                        image: "",
                        imageFile: "",
                        guestDescription: "",
                        guestFullName: "",

                        // Quote
                        quote: "",

                        // Daily News
                        slides: [
                          {
                            image: "",
                            imageFile: "",
                            description: "",
                          },
                        ],

                        // Podcast Guest Carousel
                        guestCarouselSlides: [
                          {
                            image: "",
                            imageFile: "",
                            guestDescription: "",
                            guestFullName: "",
                          },
                        ],
                      },
                      scheduleId: "",

                      // templateData:
                      //   typeof item.templateData === "string"
                      //     ? JSON.parse(item.templateData)
                      //     : item.templateData || {},
                      guestImageFile: null,
                      // templateName: "",
                      templateName: "",
                      type: "",
                    }}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={handelSubmitNNew}
                  >
                    {(props) => {
                      const onDragEnd = (result) => {
                        if (!result.destination) return;

                        const items = [...props.values.images];

                        const [reorderedItem] = items.splice(
                          result.source.index,
                          1
                        );

                        items.splice(
                          result.destination.index,
                          0,
                          reorderedItem
                        );

                        props.setFieldValue("images", items);
                      };

                      return (
                        <Form>
                          <div
                            style={{
                              position: "fixed",
                              left: "-9999px",
                              top: 0,
                              visibility: "visible",
                              zIndex: -1,
                            }}
                          >
                            {props.values.templateData?.guestImage &&
                              props.values.templateData?.firstName &&
                              props.values.templateData.lastName && (
                                <div ref={podcastGuestRef}>
                                  <PodcastCard
                                    guestImage={
                                      props.values.templateData.guestImage
                                    }
                                    firstName={
                                      props.values.templateData.firstName
                                    }
                                    lastName={
                                      props.values.templateData.lastName
                                    }
                                  />
                                </div>
                              )}

                            {props.values.templateData.quote && (
                              <div ref={quoteRef}>
                                <QuoteCard
                                  quote={props.values.templateData.quote}
                                />
                              </div>
                            )}
                            {currentTemplateSlide.carousel?.image &&
                              currentTemplateSlide.carousel?.description && (
                                <div ref={carouselRef}>
                                  <CrouselNewsCard
                                    image={currentTemplateSlide.carousel.image}
                                    description={
                                      currentTemplateSlide.carousel.description
                                    }
                                  />
                                </div>
                              )}

                            {props.values.templateName ===
                              "podcastGuestSecond" && (
                              <div ref={podcastGuestSecondRef}>
                                <PodcastGuest2Card
                                  image={
                                    currentTemplateSlide.podcastGuestSecond
                                      ?.image || ""
                                  }
                                  guestDescription={
                                    currentTemplateSlide.podcastGuestSecond
                                      ?.guestDescription || ""
                                  }
                                  guestFullName={
                                    currentTemplateSlide.podcastGuestSecond
                                      ?.guestFullName || ""
                                  }
                                />
                              </div>
                            )}
                          </div>
                          <div className="modal-body">
                            {/* Page Name */}

                            <div className="row mb-3">
                              <label className="form-label col-3 required">
                                Schedule ID
                              </label>

                              <div className="col-9">
                                <select
                                  className="form-select"
                                  value={props.values.scheduleId}
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      "scheduleId",
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="">Select Schedule ID</option>

                                  {schedules.map((item) => (
                                    <option
                                      key={item.scheduleGroupId}
                                      value={item.scheduleGroupId}
                                    >
                                      {item.scheduleGroupId}({item.scheduleName}
                                      )
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label className="form-label col-3 required">
                                Type
                              </label>

                              <div className="col-9">
                                <select
                                  className="form-select"
                                  value={props.values.type}
                                  onChange={(e) => {
                                    props.setFieldValue("type", e.target.value);
                                  }}
                                >
                                  <option value="">Select</option>
                                  <option value="Manual Upload">
                                    Manual Upload
                                  </option>
                                  <option value="Template Upload">
                                    Template Upload
                                  </option>
                                </select>
                                {props.touched.type && props.errors.type && (
                                  <p className="text-danger">
                                    {" "}
                                    {props.errors.type}{" "}
                                  </p>
                                )}
                              </div>
                            </div>

                            {props.values.type === "Template Upload" && (
                              <div className="row mb-3">
                                <label className="form-label col-3">
                                  Template
                                </label>

                                <div className="col-9">
                                  <select
                                    className="form-select"
                                    value={props.values.templateName}
                                    onChange={(e) => {
                                      props.setFieldValue(
                                        "templateName",
                                        e.target.value
                                      );
                                    }}
                                  >
                                    <option value="">Select Template</option>
                                    <option value="podcastGuest">
                                      We Are Live On YouTube(PLAN-1784116305499)
                                    </option>
                                    <option value="podcastGuestSecond">
                                      3 Guest-quote Carousels + Final Promo
                                      Image (previous
                                      Podcast)(PLAN-1784116206988)
                                    </option>
                                    <option value="quote">
                                      Quote(HM) && Quote(OTWSD)
                                    </option>
                                    <option value="carousel">
                                      This Week In Horticultural (top 5 News Of
                                      The Week)(PLAN-1783936989539)
                                    </option>
                                  </select>
                                </div>
                              </div>
                            )}

                            {props.values.templateName && (
                              <div className="row mb-3">
                                <label className="form-label col-3">
                                  Preview Template
                                </label>

                                <div className="col-9">
                                  <img
                                    src={
                                      templatePreview[props.values.templateName]
                                    }
                                    alt="Template Preview"
                                    style={{
                                      width: "150px",
                                      height: "auto",
                                      border: "1px solid #ddd",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            {/* Media */}
                            <div className="row mb-3">
                              <label className="form-label col-3">Media</label>

                              <div className="col-9">
                                <CustomInput
                                  ref={fileInputRef}
                                  name="images"
                                  type="file"
                                  accept="image/*,video/*"
                                  multiple
                                  onChange={(e) => {
                                    const files = Array.from(e.target.files);
                                    // props.setFieldValue(
                                    //   "images",
                                    //   files
                                    // );

                                    props.setFieldValue("images", [
                                      ...(props.values.images || []),
                                      ...files,
                                    ]);
                                    if (fileInputRef.current) {
                                      fileInputRef.current.value = "";
                                    }
                                  }}
                                />

                                <DragDropContext onDragEnd={onDragEnd}>
                                  <Droppable
                                    droppableId="images"
                                    direction="horizontal"
                                  >
                                    {(provided) => (
                                      <div
                                        className="d-flex flex-wrap gap-3 mt-3 border"
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                      >
                                        {props?.values.images?.map(
                                          (file, index) => {
                                            const src = getFileSrc(file);

                                            return (
                                              <Draggable
                                                key={index.toString()}
                                                draggableId={index.toString()}
                                                index={index}
                                              >
                                                {(provided) => (
                                                  <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className="border p-2 text-center"
                                                  >
                                                    {isVideo(file) ? (
                                                      <video
                                                        src={src}
                                                        controls
                                                        style={{
                                                          width: 100,
                                                          height: 100,
                                                          objectFit: "cover",
                                                        }}
                                                      />
                                                    ) : (
                                                      <img
                                                        src={src}
                                                        alt="preview"
                                                        style={{
                                                          width: 100,
                                                          height: 100,
                                                          objectFit: "cover",
                                                        }}
                                                      />
                                                    )}

                                                    <br />

                                                    <button
                                                      type="button"
                                                      className="btn btn-danger btn-sm mt-2"
                                                      onClick={() => {
                                                        const removedFile =
                                                          props?.values.images[
                                                            index
                                                          ];

                                                        if (
                                                          typeof removedFile ===
                                                          "string"
                                                        ) {
                                                          props.setFieldValue(
                                                            "deletedImages",
                                                            [
                                                              ...(props?.values
                                                                .deletedImages ||
                                                                []),
                                                              removedFile,
                                                            ]
                                                          );
                                                        }

                                                        props.setFieldValue(
                                                          "images",
                                                          props.values.images.filter(
                                                            (_, i) =>
                                                              i !== index
                                                          )
                                                        );

                                                        if (
                                                          fileInputRef.current
                                                        ) {
                                                          fileInputRef.current.value =
                                                            "";
                                                        }
                                                      }}
                                                    >
                                                      Remove
                                                    </button>
                                                  </div>
                                                )}
                                              </Draggable>
                                            );
                                          }
                                        )}

                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              </div>
                            </div>

                            {/* script */}

                            <div className="row mb-3">
                              <label className="form-label col-3 required">
                                Script
                              </label>

                              <div className="col-9">
                                <CustomTextArea name="script" type="text" />
                                {props.touched.script &&
                                  props.errors.script && (
                                    <p className="text-danger">
                                      {" "}
                                      {props.errors.script}{" "}
                                    </p>
                                  )}
                              </div>
                            </div>

                            {/* <div className="mb-3 row">
                                      <label className="w-25 form-label col-3">
                                        Platforms
                                      </label>

                                      <div className="w-100 col">
                                        {[
                                          "instagram",
                                          "facebook",
                                          "youtube",
                                          "linkdin",
                                          "X.com",
                                          "Threads",
                                        ].map((platform) => (
                                          <div
                                            className="form-check"
                                            key={platform}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={platform}
                                              checked={props.values.platforms.includes(
                                                platform
                                              )}
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  props.setFieldValue(
                                                    "platforms",
                                                    [
                                                      ...props.values.platforms,
                                                      platform,
                                                    ]
                                                  );
                                                } else {
                                                  props.setFieldValue(
                                                    "platforms",
                                                    props.values.platforms.filter(
                                                      (p) => p !== platform
                                                    )
                                                  );
                                                }
                                              }}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={platform}
                                            >
                                              {platform
                                                .charAt(0)
                                                .toUpperCase() +
                                                platform.slice(1)}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    </div> */}

                            {props.values.type === "Template Upload" && (
                              <>
                                {/* <hr className="p-0 m-0"></hr> */}
                                <h3 className="p-0 m-0">Template Details</h3>
                                {/* <hr className="p-0 m-0"></hr> */}
                                <div className="mb-2"></div>
                                <div>
                                  {props.values.templateName ===
                                    "podcastGuest" && (
                                    <>
                                      <div className="row mb-3">
                                        <label className="form-label col-3 required">
                                          Live Date
                                        </label>

                                        <div className="col-9">
                                          <input
                                            type="date"
                                            className="form-control"
                                            value={props.values.liveDate || ""}
                                            onChange={(e) =>
                                              props.setFieldValue(
                                                "liveDate",
                                                e.target.value
                                              )
                                            }
                                          />

                                          {props.touched.liveDate &&
                                            props.errors.liveDate && (
                                              <p className="text-danger">
                                                {props.errors.liveDate}
                                              </p>
                                            )}
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label className="form-label col-3">
                                          Guest Image
                                        </label>

                                        <div className="col-9">
                                          <input
                                            type="file"
                                            accept="image/*"
                                            className="form-control"
                                            onChange={(e) => {
                                              const file = e.target.files[0];

                                              if (!file) return;

                                              // Store original file
                                              props.setFieldValue(
                                                "guestImageFile",
                                                file
                                              );

                                              // Convert to Base64
                                              const reader = new FileReader();

                                              reader.onload = () => {
                                                props.setFieldValue(
                                                  "templateData.guestImage",
                                                  reader.result
                                                );
                                              };

                                              reader.readAsDataURL(file);
                                            }}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mb-3">
                                        <label className="form-label col-3">
                                          First Name
                                        </label>

                                        <div className="col-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              props.values.templateData
                                                .firstName
                                            }
                                            onChange={(e) =>
                                              props.setFieldValue(
                                                "templateData.firstName",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="row mb-3">
                                        <label className="form-label col-3">
                                          Last Name
                                        </label>
                                        <div className="col-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              props.values.templateData.lastName
                                            }
                                            onChange={(e) =>
                                              props.setFieldValue(
                                                "templateData.lastName",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  {/* {props.values.templateName ===
                                                                "podcastGuestSecond" && (
                                                                <>
                                                                  <div className="row mb-3">
                                                                    <label className="form-label col-3">
                                                                      Guest Image
                                                                    </label>
                    
                                                                    <div className="col-9">
                                                                      <input
                                                                        type="file"
                                                                        accept="image/*"
                                                                        className="form-control"
                                                                        onChange={(e) => {
                                                                          const file =
                                                                            e.target.files[0];
                    
                                                                          if (!file) return;
                    
                                                                          // Store original file
                                                                          props.setFieldValue(
                                                                            "imageFile",
                                                                            file
                                                                          );
                    
                                                                          // Convert to Base64
                                                                          const reader =
                                                                            new FileReader();
                    
                                                                          reader.onload = () => {
                                                                            props.setFieldValue(
                                                                              "templateData.image",
                                                                              reader.result
                                                                            );
                                                                          };
                    
                                                                          reader.readAsDataURL(
                                                                            file
                                                                          );
                                                                        }}
                                                                      />
                                                                    </div>
                                                                  </div>
                    
                                                                  <div className="row mb-3">
                                                                    <label className="form-label col-3">
                                                                      Description
                                                                    </label>
                    
                                                                    <div className="col-9">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={
                                                                          props.values.templateData
                                                                            .guestDescription
                                                                        }
                                                                        onChange={(e) =>
                                                                          props.setFieldValue(
                                                                            "templateData.guestDescription",
                                                                            e.target.value
                                                                          )
                                                                        }
                                                                      />
                                                                    </div>
                                                                  </div>
                    
                                                                  <div className="row mb-3">
                                                                    <label className="form-label col-3">
                                                                      Full Name
                                                                    </label>
                                                                    <div className="col-9">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={
                                                                          props.values.templateData
                                                                            .guestFullName
                                                                        }
                                                                        onChange={(e) =>
                                                                          props.setFieldValue(
                                                                            "templateData.guestFullName",
                                                                            e.target.value
                                                                          )
                                                                        }
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              )} */}

                                  {props.values.templateName ===
                                    "podcastGuestSecond" && (
                                    <>
                                      {props.values.templateData.guestCarouselSlides.map(
                                        (guest, index) => (
                                          <div
                                            key={index}
                                            className="border rounded p-3 mb-3"
                                          >
                                            <h5>Guest {index + 1}</h5>

                                            <input
                                              type="file"
                                              className="form-control mb-2"
                                              accept="image/*"
                                              onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (!file) return;

                                                const reader = new FileReader();

                                                reader.onload = () => {
                                                  const slides = [
                                                    ...props.values.templateData
                                                      .guestCarouselSlides,
                                                  ];

                                                  slides[index].image =
                                                    reader.result;
                                                  slides[index].imageFile =
                                                    file;

                                                  props.setFieldValue(
                                                    "templateData.guestCarouselSlides",
                                                    slides
                                                  );
                                                };

                                                reader.readAsDataURL(file);
                                              }}
                                            />

                                            <input
                                              type="text"
                                              className="form-control mb-2"
                                              placeholder="Guest Description"
                                              value={guest.guestDescription}
                                              onChange={(e) => {
                                                const slides = [
                                                  ...props.values.templateData
                                                    .guestCarouselSlides,
                                                ];

                                                slides[index].guestDescription =
                                                  e.target.value;

                                                props.setFieldValue(
                                                  "templateData.guestCarouselSlides",
                                                  slides
                                                );
                                              }}
                                            />

                                            <input
                                              type="text"
                                              className="form-control mb-2"
                                              placeholder="Guest Full Name"
                                              value={guest.guestFullName}
                                              onChange={(e) => {
                                                const slides = [
                                                  ...props.values.templateData
                                                    .guestCarouselSlides,
                                                ];

                                                slides[index].guestFullName =
                                                  e.target.value;

                                                props.setFieldValue(
                                                  "templateData.guestCarouselSlides",
                                                  slides
                                                );
                                              }}
                                            />

                                            <button
                                              type="button"
                                              className="btn btn-danger mt-3"
                                              onClick={() => {
                                                const slides = [
                                                  ...props.values.templateData
                                                    .guestCarouselSlides,
                                                ];

                                                slides.splice(index, 1);

                                                props.setFieldValue(
                                                  "templateData.guestCarouselSlides",
                                                  slides
                                                );
                                              }}
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )
                                      )}

                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                          props.setFieldValue(
                                            "templateData.guestCarouselSlides",
                                            [
                                              ...props.values.templateData
                                                .guestCarouselSlides,
                                              {
                                                image: "",
                                                imageFile: null,
                                                guestDescription: "",
                                                guestFullName: "",
                                              },
                                            ]
                                          );
                                        }}
                                      >
                                        + Add Slide
                                      </button>
                                    </>
                                  )}
                                  {props.values.templateName === "quote" && (
                                    <>
                                      <div className="row mb-3">
                                        <label className="form-label col-3">
                                          Quote
                                        </label>

                                        <div className="col-9">
                                          <textarea
                                            className="form-control"
                                            rows="5"
                                            value={
                                              props.values.templateData
                                                ?.quote || ""
                                            }
                                            onChange={(e) =>
                                              props.setFieldValue(
                                                "templateData.quote",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  {props.values.templateName === "carousel" && (
                                    <>
                                      {props.values.templateData.slides.map(
                                        (slide, index) => (
                                          <div
                                            key={index}
                                            className="border rounded p-3 mb-3"
                                          >
                                            <h5>Slide {index + 1}</h5>

                                            <input
                                              type="file"
                                              className="form-control mb-2"
                                              accept="image/*"
                                              onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (!file) return;

                                                const reader = new FileReader();

                                                reader.onload = () => {
                                                  const slides = [
                                                    ...props.values.templateData
                                                      .slides,
                                                  ];
                                                  slides[index].image =
                                                    reader.result;
                                                  slides[index].imageFile =
                                                    file;

                                                  props.setFieldValue(
                                                    "templateData.slides",
                                                    slides
                                                  );
                                                };

                                                reader.readAsDataURL(file);
                                              }}
                                            />

                                            <textarea
                                              className="form-control"
                                              rows={4}
                                              placeholder="Description"
                                              value={slide.description}
                                              onChange={(e) => {
                                                const slides = [
                                                  ...props.values.templateData
                                                    .slides,
                                                ];
                                                slides[index].description =
                                                  e.target.value;

                                                props.setFieldValue(
                                                  "templateData.slides",
                                                  slides
                                                );
                                              }}
                                            />

                                            <button
                                              type="button"
                                              className="btn btn-danger mt-3"
                                              onClick={() => {
                                                const slides = [
                                                  ...props.values.templateData
                                                    .slides,
                                                ];
                                                slides.splice(index, 1);

                                                props.setFieldValue(
                                                  "templateData.slides",
                                                  slides
                                                );
                                              }}
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )
                                      )}

                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                          props.setFieldValue(
                                            "templateData.slides",
                                            [
                                              ...props.values.templateData
                                                .slides,
                                              {
                                                image: "",
                                                imageFile: null,
                                                description: "",
                                              },
                                            ]
                                          );
                                        }}
                                      >
                                        + Add Slide
                                      </button>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>

                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>

                            {/* <FormSubmitButton buttonText="Update" /> */}
                            <FormSubmitButton
                              buttonText={submitting ? "Updating..." : "Update"}
                              disabled={submitting}
                            />
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default Editpodcast;
